import { buildFacetDesignOverride } from 'Packages/FacetRest/FacetDesignOverride';

export const overrideSet = buildFacetDesignOverride();
